/* eslint-disable */
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "../../services/Axios/axios";
import RenderITOfficerPage from "../RenderITOfficerPage";
import UploadCard from "../components/UploadCard";

function UploadMembers() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const handleUpload = async (file, extra) => {
    if (!extra?.date_joined) {
      toast.error("Date Joined is required (e.g. FEB26)");
      return;
    }
    setIsLoading(true);
    setResponse(null);
    try {
      const formData = new FormData();
      formData.append("file", file);
      await axiosInstance.post(`/users/upload?date_joined=${encodeURIComponent(extra.date_joined)}`, formData);
      setResponse({ state: "SUCCESS", message: "Members uploaded successfully. Processing in background." });
      toast.success("Members uploaded successfully");
    } catch (e) {
      const msg = e?.response?.data?.message ?? "Upload failed. Try again.";
      setResponse({ state: "ERROR", message: msg });
      toast.error(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <RenderITOfficerPage title="Upload Members">
      <UploadCard
        title="Bulk Upload Members"
        description="Upload an Excel or CSV file to bulk-create member accounts. Optionally set a join date."
        onUpload={handleUpload}
        extras={[
          {
            name: "date_joined",
            label: "Date Joined",
            type: "text",
            placeholder: "e.g. FEB26",
            required: true,
          },
        ]}
        isLoading={isLoading}
        response={response}
        accentColor="orange"
      />
      <ToastContainer autoClose={3000} />
    </RenderITOfficerPage>
  );
}

export default UploadMembers;
